import { useEffect } from "react";
import { useLocation } from "react-router";

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Force la page à remonter instantanément en haut (coordonnées 0,0)
        window.scrollTo(0, 0);

        // Alternative si vous voulez un effet de glissement fluide :
        // window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]); // Se déclenche à chaque fois que le chemin de l'URL change

    return null; // Ce composant ne外 rend rien visuellement
}